if (typeof boostPFSThemeConfig !== 'undefined') {
  // Override Settings
  var boostPFSFilterConfig = {
    general: {
      limit: boostPFSConfig.custom.products_per_page,
      loadProductFirst: true,
      selectOptionContainer: '.grid__item .card-wrapper',
      stickyFixTopPos: true
    },
    selector: {
      otpButtons: '.card .card__inner',
      otpTopCartCount: '.cart-count-bubble'
    }
  };
}

(function () {
  var onSale = false,
    soldOut = false,
    priceVaries = false,
    images = [],
    boostPFSRangeWidths = [165, 360, 533, 720, 940, 1066];


  BoostPFS.inject(this);
  /* For Filter Setting Layout */
  Selector.stickyElementDesktop = jQ('.boost-pfs-filter-left-col').length > 0 && !Utils.isMobile() ? '.boost-pfs-filter-left-col' : '.boost-pfs-filter-tree';
  //custom change frontida->Φροντίδα
  // if (boostPFSConfig && boostPFSConfig?.settings?.general?.shortenUrlParamList) {
  //     boostPFSConfig.settings.general.shortenUrlParamList.forEach((item, index, array) => {
  //       if (item === 'pf_t_frontida:frontida') {
  //         array[index] = 'pf_t_frontida:Φροντίδα';
  //       }
  //     });
  //   }
  //end custom change frontida->Φροντίδα
  
  /************************** CUSTOMIZE DATA BEFORE BUILDING PRODUCT ITEM **************************/
  function prepareShopifyData(data) {
    // Displaying price base on the policy of Shopify, have to multiple by 100
    soldOut = !data.available; // Check a product is out of stock
    onSale = data.compare_at_price_min > data.price_min; // Check a product is on sale
    priceVaries = data.price_min != data.price_max; // Check a product has many prices
    // Convert images to array
    images = data.images_info;
    // Get First Variant (selected_or_first_available_variant)
    firstVariant = data['variants'][0];
    if (Utils.getParam('variant') !== null && Utils.getParam('variant') != '') {
      var paramVariant = data.variants.filter(function (e) {
        return e.id == Utils.getParam('variant');
      });
      if (typeof paramVariant[0] !== 'undefined') firstVariant = paramVariant[0];
    } else {
      for (var i = 0; i < data['variants'].length; i++) {
        if (data['variants'][i].available) {
          firstVariant = data['variants'][i];
          break;
        }
      }
    }
    return data;
  }

  /************************** END CUSTOMIZE DATA BEFORE BUILDING PRODUCT ITEM **************************/
  /************************** BUILD PRODUCT LIST **************************/
  // Build Product Grid Item
  ProductGridItem.prototype.compileTemplate = function (data) {
    if (!data) data = this.data;
    // Customize API data to get the Shopify data
    data = prepareShopifyData(data);

    // Get Template
    var itemHtml = boostPFSTemplate.productGridItemHtml;
    // Add Custom class
    var imageAspectRatio = getAspectRatio(data.images_info[0]) * 100;

    itemHtml = itemHtml.replace(/{{imageAspectRatio}}/g, imageAspectRatio);

    // Add Card product class
    itemHtml = itemHtml.replace(/{{cardProductClass}}/g, buildCardProductClass(data));
    // Add Card inner product class
    itemHtml = itemHtml.replace(/{{cardInnerProductClass}}/g, buildCardInnerProductClass(data));
    // Add Card badge position
    itemHtml = itemHtml.replace(/{{cardBadgePosition}}/g, boostPFSThemeConfig.custom.badge_position);
    // Add check card heading five
    itemHtml = itemHtml.replace(/{{cardIsHeadingFive}}/g, buildCardIsHeadingFive(data));
    // Add sold out Label
    itemHtml = itemHtml.replace(/{{itemSoldOut}}/g, buildSoldOutLabel());
    // Add sale Label
    itemHtml = itemHtml.replace(/{{itemSale}}/g, buildSaleLabel());
    // Add Images
    itemHtml = itemHtml.replace(/{{itemImages}}/g, buildImages(data));
    // Add Price
    itemHtml = itemHtml.replace(/{{itemPrice}}/g, buildPrice(data));


    // Add Review
    if (typeof Integration === 'undefined' ||
      (typeof Integration != 'undefined' &&
        typeof Integration.hascompileTemplate == 'function' &&
        !Integration.hascompileTemplate('reviews'))) {
      itemHtml = itemHtml.replace(/{{itemReviews}}/g, buildReview(data));
    }

    // Add Description
    itemHtml = itemHtml.replace(/{{itemDescription}}/g, boostPFSThemeConfig.custom.description || '');

    // Add Vendor
    itemHtml = itemHtml.replace(/{{itemVendor}}/g, buildVendor(data));

    // Add main attribute (Always put at the end of this function)
    itemHtml = itemHtml.replace(/{{itemId}}/g, data.id);
    itemHtml = itemHtml.replace(/{{itemTitle}}/g, data.title);
    itemHtml = itemHtml.replace(/{{itemHandle}}/g, data.handle);
    itemHtml = itemHtml.replace(/{{itemVendorLabel}}/g, data.vendor);
    itemHtml = itemHtml.replace(/{{itemUrl}}/g, Utils.buildProductItemUrlWithVariant(data));
    return itemHtml;
  };

  /************************** END BUILD PRODUCT LIST **************************/
  /************************** BUILD PRODUCT ITEM ELEMENTS **************************/
  function buildImages(data) {
    var html = '',
      aspectRatio = '',
      rangeWidths = boostPFSRangeWidths,
      paddingBottom = 100;

    var dataSrcSet = '',
      imgAlt = data.title,
      flipImageSrcSet = '';

    var activeSwapImage = !Utils.isMobile() && images.length > 1 &&
      boostPFSThemeConfig.custom.hasOwnProperty('show_secondary_image') &&
      boostPFSThemeConfig.custom.show_secondary_image == true;

    for (var i = 0; i < rangeWidths.length; i++) {
      dataSrcSet += Utils.getFeaturedImage(images, rangeWidths[i] + 'x') + ' ' + rangeWidths[i] + 'w';

      if (activeSwapImage) {
        flipImageSrcSet += Utils.optimizeImage(images[1]['src'], rangeWidths[i] + 'x') + ' ' + rangeWidths[i] + 'w';
      }

      if (i < rangeWidths.length - 1) {
        dataSrcSet += ', ';

        if (activeSwapImage) {
          flipImageSrcSet += ', ';
        }
      }
    }

    if (images.length > 0) {
      aspectRatio = images[0]['width'] / images[0]['height'];
      html += '<div class="media media--transparent media--hover-effect">';
      html += '<img class="motion-reduce"' +
        'loading="lazy"' +
        'srcset="' + dataSrcSet + '" ' +
        'height="' + images[0].height + '" ' +
        'width="' + images[0].width + '" ' +
        'sizes="(min-width: 1100px) 535px, (min-width: 990px) calc((100vw - 130px) / 4), (min-width: 750px) calc((100vw - 120px) / 3), calc((100vw - 35px) / 2)"' +
        'src="' + Utils.optimizeImage(images[0].src, '533x') + '" ' +
        'alt="' + imgAlt + '" />';

      if (activeSwapImage) {
        html += '<img class="motion-reduce"' +
          'loading="lazy"' +
          'srcset="' + flipImageSrcSet + '" ' +
          'height="' + images[1].height + '" ' +
          'width="' + images[1].width + '" ' +
          'sizes="(min-width: 1100px) 535px, (min-width: 990px) calc((100vw - 130px) / 4), (min-width: 750px) calc((100vw - 120px) / 3), calc((100vw - 35px) / 2)"' +
          'src="' + Utils.optimizeImage(images[1].src, '533x') + '" ' +
          'alt="' + imgAlt + '" />';
      }
      html += '</div>';
    } else {
      html += '<div class="card__content"><h2 class="card__text h2">' + data.title + '</h2></div>'
    }
    return html;
  }

  function buildCardProductClass(data) {
    var html = boostPFSThemeConfig.custom.card_style;
    if (!images || (images && images.length === 0)) {
      html += ' card--text';
    } else {
      html += ' card--media';
    }
    if (boostPFSThemeConfig.custom.card_style == 'card') {
      html += ' color-' + boostPFSThemeConfig.custom.card_color_scheme;
    }
    if ((!images || (images && images.length === 0)) && boostPFSThemeConfig.custom.card_style == 'card') {
      html += ' ratio';
    }
    return html;
  }

  function buildCardInnerProductClass(data) {
    var html = '';
    if (boostPFSThemeConfig.custom.card_style == 'standard') {
      html += ' color-' + boostPFSThemeConfig.custom.card_color_scheme;
    }
    if (images || boostPFSThemeConfig.custom.card_style == 'standard') {
      html += ' ratio';
    }
    return html;
  }

  function buildCardIsHeadingFive(data) {
    var html = '';
    if (images || boostPFSThemeConfig.custom.card_style == 'standard') {
      html = 'h5';
    }
    return html;
  }

  function buildVendor(data) {
    var html = '';
    if (boostPFSThemeConfig.custom.hasOwnProperty('show_vendor') &&
      boostPFSThemeConfig.custom.show_vendor === true) {
      html = boostPFSTemplate.vendorHtml;
    }
    return html;
  }

  function buildPrice(data) {
    var html = '';
    var noComparePrice = data.price_varies === false && data.compare_at_price_varies;
    var priceAmount = boostPFSConfig.custom.currency_code_enabled ? Utils.formatMoney(data.price_min, 'money_with_currency') : Utils.formatMoney(data.price_min);
    var compareAtPrice = boostPFSConfig.custom.currency_code_enabled ? Utils.formatMoney(data.compare_at_price_min, 'money_with_currency') : Utils.formatMoney(data.compare_at_price_min);
    var moneyPrice = priceVaries ? boostPFSConfig.label.from_price_html.replace(/{{ price }}/, priceAmount)
      : priceAmount;
    var unitPriceClass = !data.available || typeof data?.selected_or_first_available_variant?.unit_price_measurement === 'undefined' ? 'hidden' : ''
    html = `<div class="price ${soldOut ? 'price--sold-out' : ''} ${onSale ? 'price--on-sale' : ''}${noComparePrice ? 'price--no-compare' : ''}">
					<div class="price__container">
						<div class="price__regular">
							<span class="visually-hidden visually-hidden--inline">
								${boostPFSConfig.label.regular_price}
							</span>
							<span class="price-item price-item--regular">
								${moneyPrice}
							</span>
						</div>
						<div class="price__sale">
							<span class="visually-hidden visually-hidden--inline">
								${boostPFSConfig.label.regular_price}
							</span>
							<span>
								<s class="price-item price-item--regular">
									${compareAtPrice}
								</s>
							</span>
							<span class="visually-hidden visually-hidden--inline">${boostPFSConfig.label.sale_price}</span>
							<span class="price-item price-item--sale price-item--last">
								${moneyPrice}
							</span>
						</div>
						<small class="unit-price caption ${unitPriceClass}">
							<span class="visually-hidden">${boostPFSConfig.label.unit_price}</span>
							<span class="price-item price-item--last">
								<span>${Utils.formatMoney(data.selected_or_first_available_variant && data.selected_or_first_available_variant.unit_price)}</span>
								<span aria-hidden="true">/</span>
								<span class="visually-hidden">&nbsp;${boostPFSConfig.label.unit_price_separator}&nbsp;</span>
							</span>
					  </small>
					</div>
				</div>`
    return html;
  }

  function buildSoldOutLabel() {
    // Build Sold out label
    var soldOutLabel = '';
    if (boostPFSThemeConfig.custom.hasOwnProperty('sold_out_badge_color_scheme') && soldOut) {
      soldOutLabel = boostPFSTemplate.soldOutLabelHtml.replace(/{{soldOutBadgeClass}}/g, boostPFSThemeConfig.custom.sold_out_badge_color_scheme);
    }
    return soldOutLabel;
  }

  function buildSaleLabel() {
    // Build Sale label
    var saleLabel = '';
    if (boostPFSThemeConfig.custom.hasOwnProperty('sale_badge_color_scheme') && onSale && !soldOut) {
      saleLabel = boostPFSTemplate.saleLabelHtml.replace(/{{saleBadgeClass}}/g, boostPFSThemeConfig.custom.sale_badge_color_scheme);
    }
    return saleLabel;
  }

  function buildReview(data) {
    var html = '';
    if (boostPFSThemeConfig.custom.hasOwnProperty('show_product_review') &&
      boostPFSThemeConfig.custom.show_product_review == true && Utils.getProductMetafield(data, 'reviews', 'rating') !== null) {
      var ratingObj = JSON.parse(Utils.getProductMetafield(data, 'reviews', 'rating'));
      var rating_decimal = 0;
      var decimal = parseFloat(ratingObj.value.rating);
      if (decimal >= 0.3 && decimal <= 0.7) {
        rating_decimal = 0.5;
      } else if (decimal > 0.7) {
        rating_decimal = 1;
      }
      html = `<div class="rating" role="img" aria-label="${boostPFSConfig.label.star_reviews_info.replace('{{ rating_value }}', ratingObj.value).replace('{{ rating_max }}', ratingObj.value.scale_max)}">
                <span aria-hidden="true" class="rating-star color-icon-${boostPFSConfig.custom.accent_icons}" style="--rating: ${Math.round(ratingObj.value.rating)}; --rating-max: ${ratingObj.value.scale_max}; --rating-decimal: ${rating_decimal};"></span>
              </div>
              <p class="rating-text caption">
                <span aria-hidden="true">${ratingObj.value} / ${ratingObj.value.scale_max}</span>
              </p>
              <p class="rating-count caption">
                <span aria-hidden="true">(${Utils.getProductMetafield(data, 'reviews', 'rating_count')})</span>
                <span class="visually-hidden">${Utils.getProductMetafield(data, 'reviews', 'rating_count')} ${boostPFSConfig.label.total_reviews}</span>
              </p>`;
    }
    return html;
  }

  function getAspectRatio(data) {
    var ratio = 1;
    if (data && boostPFSThemeConfig.custom.image_ratio === 'portrait') {
      ratio = 0.8;
    } else if (data && boostPFSThemeConfig.custom.image_ratio === 'adapt') {
      var width = (data == null) ? '535' : data.width;
      var height = (data == null) ? '535' : data.height;
      ratio = height / width;
    }
    if (!ratio) {
      ratio = 1;
    }
    return ratio;
  }

  /************************** END BUILD PRODUCT ITEM ELEMENTS **************************/
  /************************** BUILD TOOLBAR **************************/
  // Build Pagination
  ProductPaginationDefault.prototype.compileTemplate = function (totalProduct) {
    if (!totalProduct) totalProduct = this.totalProduct;
    // Get page info
    var currentPage = parseInt(Globals.queryParams.page);
    var totalPage = Math.ceil(totalProduct / Globals.queryParams.limit);
    // If it has only one page, clear Pagination
    if (totalPage <= 1) {
      return '';
    }

    var paginationHtml = boostPFSTemplate.paginateHtml;
    // Build Previous
    var previousHtml = (currentPage > 1) ? boostPFSTemplate.previousActiveHtml : '';
    previousHtml = previousHtml.replace(/{{itemUrl}}/g, Utils.buildToolbarLink('page', currentPage, currentPage - 1));
    paginationHtml = paginationHtml.replace(/{{previous}}/g, previousHtml);
    // Build Next
    var nextHtml = (currentPage < totalPage) ? boostPFSTemplate.nextActiveHtml : '';
    nextHtml = nextHtml.replace(/{{itemUrl}}/g, Utils.buildToolbarLink('page', currentPage, currentPage + 1));
    paginationHtml = paginationHtml.replace(/{{next}}/g, nextHtml);
    // Create page items array
    var beforeCurrentPageArr = [];
    for (var iBefore = currentPage - 1; iBefore > currentPage - 3 && iBefore > 0; iBefore--) {
      beforeCurrentPageArr.unshift(iBefore);
    }
    if (currentPage - 4 > 0) {
      beforeCurrentPageArr.unshift('...');
    }
    if (currentPage - 4 >= 0) {
      beforeCurrentPageArr.unshift(1);
    }
    beforeCurrentPageArr.push(currentPage);
    var afterCurrentPageArr = [];
    for (var iAfter = currentPage + 1; iAfter < currentPage + 3 && iAfter <= totalPage; iAfter++) {
      afterCurrentPageArr.push(iAfter);
    }
    if (currentPage + 3 < totalPage) {
      afterCurrentPageArr.push('...');
    }
    if (currentPage + 3 <= totalPage) {
      afterCurrentPageArr.push(totalPage);
    }
    // Build page items
    var pageItemsHtml = '';
    var pageArr = beforeCurrentPageArr.concat(afterCurrentPageArr);
    for (var iPage = 0; iPage < pageArr.length; iPage++) {
      if (pageArr[iPage] == '...') {
        pageItemsHtml += boostPFSTemplate.pageItemRemainHtml;
      } else {
        pageItemsHtml += (pageArr[iPage] == currentPage) ? boostPFSTemplate.pageItemSelectedHtml : boostPFSTemplate.pageItemHtml;
      }
      pageItemsHtml = pageItemsHtml.replace(/{{itemTitle}}/g, pageArr[iPage]);
      pageItemsHtml = pageItemsHtml.replace(/{{itemUrl}}/g, Utils.buildToolbarLink('page', currentPage, pageArr[iPage]));
    }
    paginationHtml = paginationHtml.replace(/{{pageItems}}/g, pageItemsHtml);
    return paginationHtml;
  };

  // Build Sorting
  ProductSorting.prototype.compileTemplate = function () {
    var html = '';
    if (boostPFSTemplate.hasOwnProperty('sortingHtml')) {
      var sortingArr = Utils.getSortingList();
      if (sortingArr) {
        var paramSort = Globals.queryParams.sort || '';
        // Build content
        var sortingItemsHtml = '';
        for (var k in sortingArr) {
          var isSelected = ''
          if (paramSort == k) {
            isSelected = 'selected="selected"'
          }
          sortingItemsHtml += '<option value="' + k + '"' + isSelected + '>' + sortingArr[k] + '</option>';
        }
        html = boostPFSTemplate.sortingHtml.replace(/{{sortingItems}}/g, sortingItemsHtml);
      }
    }
    return html;
  };

  // Build Sorting event
  ProductSorting.prototype.bindEvents = function () {
    jQ(Selector.topSorting + ' .facet-filters__sort').change(function (e) {
      e.preventDefault();
      FilterApi.setParam('sort', jQ(this).val());
      FilterApi.setParam('page', 1);
      FilterApi.applyFilter('sort');
    });
  };
  
  FilterMobileButton.prototype.getTemplate = function(){
     
     	return `
				<button type="button" aria-label="{{label}}">{{icon}} <span class="{{filterTreeMobileButton}}-label">{{label}}</span></button>
		`.trim();
   
   }
   
    FilterMobileButton.prototype.compileTemplate = function(){
      var filterOptionIds = Object.keys(Globals.queryParams).filter(key => key.startsWith(Globals.prefix));
      console.log(filterOptionIds)
      console.log(Globals.queryParams[filterOptionIds])
      var numberResults;
      
      if(Globals.queryParams[filterOptionIds] != undefined) {
         numberResults = Globals.queryParams[filterOptionIds].length;
      }else {
        numberResults='';
      }
			return this.getTemplate()
			.replace(/{{filterTreeMobileButton}}/g, Class.filterTreeMobileButton)
			.replace(/{{label}}/g, this.label)
			.replace(/{{icon}}/g, this.icon)
      .replace(/{{numberResult}}/g, numberResults)
   
   }
  

  
 //custom label
  FilterClearButton.prototype.compileTemplate = function (){
    this.buildLabel();
    switch (this.filterValueLabel) {
    case 'Extra agapi':
      this.filterValueLabel = 'Έξτρα αγάπη';
     break;
    case 'Yper-anthektika':
      this.filterValueLabel = 'Υπέρ-ανθεκτικά';
      break;
    case 'Eykola':
      this.filterValueLabel = 'Εύκολα';
      break;
    case 'Iliolousto Simeio':
      this.filterValueLabel = 'Ηλιόλουστο Σημείο';
      break;
    case 'Skiero Simeio':
      this.filterValueLabel = 'Σκιερό Σημείο';
      break;
    case 'Tha Ta Kataferei Pantou':
      this.filterValueLabel = 'Θα τα καταφέρει παντού';
      break;
    case 'Foteino Simeio':
      this.filterValueLabel = 'Φωτεινό Σημείο';
      break;
    case 'Megala':
      this.filterValueLabel = 'Μεγάλα (+1m)';
      break;
    case 'Mesaia':
      this.filterValueLabel = 'Μεσαία (50cm-1m)';
      break;
    case 'Mikra':
      this.filterValueLabel = 'Μικρά (5-50cm)';
      break;
    case 'Mpalkoni':
      this.filterValueLabel = 'Μπαλκόνι';
        break;
      case 'Khpos':
        this.filterValueLabel = 'Κήπος';
        break;
      case 'Anthizei':
        this.filterValueLabel = 'Ανθίζει';
        break;
      case 'De Rixnei Fylla':
        this.filterValueLabel = 'Δε Ρίχνει Φύλλα';
        break;
      case 'Entypwsiakh Emfanish':
        this.filterValueLabel = 'Εντυπωσιακή εμφάνιση';
        break;
      case 'Fysikos Fraxtis':
        this.filterValueLabel = 'Φυσικός φράχτης';
        break;
      case 'Anthektiko Se Aera':
        this.filterValueLabel = 'Ανθεκτικό Σε Αέρα';
        break;
      case 'Anthektiko Se Pageto':
        this.filterValueLabel = 'Ανθεκτικό Σε Παγετό';
        break;
      case 'Eyxaristo Arwma':
        this.filterValueLabel = 'Ευχάριστο Άρωμα';
        break;
      case 'Polyeth':
        this.filterValueLabel = 'Πολυετή';
        break;
      case 'Epoxiaka':
        this.filterValueLabel = 'Εποχιακά';
        break;
      case 'Anoixh':
        this.filterValueLabel = 'Άνοιξη';
        break;
      case 'Kalokairi':
        this.filterValueLabel = 'Καλοκαίρι';
        break;
      case 'Fthinopwro':
        this.filterValueLabel = 'Φθινόπωρο';
        break;
      case 'Xeimwnas':
        this.filterValueLabel = 'Χειμώνας';
        break;
      case 'Tropika':
        this.filterValueLabel = 'Τροπικά';
        break;
      case 'Arwmatika':
        this.filterValueLabel = 'Αρωματικά';
        break;
      case 'Thamnoeidh':
        this.filterValueLabel = 'Θαμνοειδή';
        break;
      case 'Loyloydia':
        this.filterValueLabel = 'Λουλούδια';
        break;
      case 'Dendroeidh':
        this.filterValueLabel = 'Δενδροειδή';
        break;
      case 'Anarrixwmena':
        this.filterValueLabel = 'Αναρριχώμενα';
        break;
      case 'Kaktoi & Paxyfyta':
        this.filterValueLabel = 'Κάκτοι & Παχύφυτα';
        break;
       /* Boost-230412 */            
      case 'Kaspo':
        this.filterValueLabel = 'Κασπώ';
        break;
      case 'Glastra':
        this.filterValueLabel = 'Γλάστρα';
        break;
      case 'Mikra (ews 14cm)':
        this.filterValueLabel = 'Μικρά (έως 14cm)';
        break;
      case 'Mesaia (14-20cm)':
        this.filterValueLabel = 'Μεσαία (14-20cm)';
        break;
      case 'Megala (>20cm)':
        this.filterValueLabel = 'Μεγάλα (>20cm)';
        break;
      case 'Xeiropoihto':
        this.filterValueLabel = 'Χειροποίητο';
        break;
    // Add more cases as needed
    // case 'AnotherLabel':
    //   this.label = 'AnotherValue';
    //   break;

    default:
      // Default case if none of the above matches
      // You might want to keep the original value or handle it differently
      break;
  }
    console.log(11,this.filterValueLabel);
		return this.getTemplate()
			.replace(/{{label.clear}}/g, Labels.clear)
			.replace(/{{class.button}}/g, Class.button)
			.replace(/{{class.clearButton}}/g, Class.clearButton)
			.replace(/{{class.clearAllButton}}/g, Class.clearAllButton)
			.replace(/{{adaLabel}}/g, Utils.stripHtml(this.adaLabel))
			.replace(/{{label}}/g, Utils.stripHtml(this.label))
			.replace(/{{filterOptionLabel}}/g, this.filterOptionLabel)
			.replace(/{{filterValueLabel}}/g, this.filterValueLabel);
  	
  }
  FilterOptionItemList.prototype.compileTemplate = function () {
   switch (this.label) {
    case 'Yper-anthektika':
      this.label = 'Υπέρ-ανθεκτικά';
      break;
    case 'Extra Agapi':
      this.label = 'Έξτρα αγάπη';
      break;
    case 'Eykola':
      this.label = 'Εύκολα';
      break;
    case 'Iliolousto Simeio':
      this.label = 'Ηλιόλουστο Σημείο';
      break;
    case 'Skiero Simeio':
      this.label = 'Σκιερό Σημείο';
      break;
    case 'Tha Ta Kataferei Pantou':
      this.label = 'Θα τα καταφέρει παντού';
      break;
    case 'Foteino Simeio':
      this.label = 'Φωτεινό Σημείο';
      break;
    case 'Megala':
      this.label = 'Μεγάλα (+1m)';
      break;
    case 'Mesaia':
      this.label = 'Μεσαία (50cm-1m)';
      break;
    case 'Mikra':
      this.label = 'Μικρά (5-50cm)';
      break;
    case 'Mpalkoni':
        this.label = 'Μπαλκόνι';
        break;
    case 'Khpos':
        this.label = 'Κήπος';
        break;
      case 'Anthizei':
        this.label = 'Ανθίζει';
        break;
      case 'De Rixnei Fylla':
        this.label = 'Δε Ρίχνει Φύλλα';
        break;
      case 'Entypwsiakh Emfanish':
        this.label = 'Εντυπωσιακή εμφάνιση';
        break;
      case 'Fysikos Fraxtis':
        this.label = 'Φυσικός φράχτης';
        break;
      case 'Anthektiko Se Aera':
        this.label = 'Ανθεκτικό Σε Αέρα';
        break;
      case 'Anthektiko Se Pageto':
        this.label = 'Ανθεκτικό Σε Παγετό';
        break;
      case 'Eyxaristo Arwma':
        this.label = 'Ευχάριστο Άρωμα';
        break;
      case 'Polyeth':
        this.label = 'Πολυετή';
        break;
      case 'Epoxiaka':
        this.label = 'Εποχιακά';
        break;
      case 'Anoixh':
        this.label = 'Άνοιξη';
        break;
      case 'Kalokairi':
        this.label = 'Καλοκαίρι';
        break;
      case 'Fthinopwro':
        this.label = 'Φθινόπωρο';
        break;
      case 'Xeimwnas':
        this.label = 'Χειμώνας';
        break;
      case 'Tropika':
        this.label = 'Τροπικά';
        break;
      case 'Arwmatika':
        this.label = 'Αρωματικά';
        break;
      case 'Thamnoeidh':
        this.label = 'Θαμνοειδή';
        break;
      case 'Loyloydia':
        this.label = 'Λουλούδια';
        break;
      case 'Dendroeidh':
        this.label = 'Δενδροειδή';
        break;
      case 'Anarrixwmena':
        this.label = 'Αναρριχώμενα';
        break;
      case 'Kaktoi & Paxyfyta':
        this.label = 'Κάκτοι & Παχύφυτα';
        break;
      /* Boost-230412 */            
      case 'Kaspo':
        this.label = 'Κασπώ';
        break;
      case 'Glastra':
        this.label = 'Γλάστρα';
        break;
      case 'Mikra (ews 14cm)':
        this.label = 'Μικρά (έως 14cm)';
        break;
      case 'Mesaia (14-20cm)':
        this.label = 'Μεσαία (14-20cm)';
        break;
      case 'Megala (>20cm)':
        this.label = 'Μεγάλα (>20cm)';
        break;
      case 'Xeiropoihto':
        this.label = 'Χειροποίητο';
        break;
    // Add more cases as needed
    // case 'AnotherLabel':
    //   this.label = 'AnotherValue';
    //   break;

    default:
      // Default case if none of the above matches
      // You might want to keep the original value or handle it differently
      break;
  }
  return this.getTemplate()
  .replace(/{{class.filterOptionItem}}/g, Class.filterOptionItem)
  .replace(/{{class.filterOptionLabel}}/g, Class.filterOptionLabel)
  .replace(/{{class.button}}/g, Class.button)
  .replace(/{{disabled}}/g, this.isDisabled() ? 'disabled' : '')
  .replace(/{{label}}/g, Utils.stripHtml(this.label))
  .replace(/{{href}}/g, this.href)
  .replace(/{{countLabel}}/g, Utils.stripHtml(this.countLabel));
  }
  // end custom
  // Add additional feature for product list, used commonly in customizing product list
  FilterTreeStyle2.prototype.renderRefineByOnTitle = function() {
		// Render refine by label on each filter option
		this.filterOptions.forEach(filterOption => {

			if (filterOption.$element) {
				var labelText = '';
				// Multi level collection label
				if (filterOption.filterOptionId.startsWith(Globals.prefix + '_c_')) {
					var filterItems = filterOption.displayType == FilterOptionEnum.DisplayType.MULTI_LEVEL_COLLECTIONS ? filterOption.allNestedFilterItems : filterOption.filterItems;
					if (filterItems && filterItems.size > 0) {
						var collectionLabel = '';
						var tagLabels = [];
						filterItems.forEach((filterItem) => {
							if (filterItem.isSelected) {
								if (filterItem.level == 2 || filterItem.level == 3) {
									tagLabels.push(Utils.stripHtml(filterItem.label));
								} else {
									collectionLabel = Utils.stripHtml(filterItem.label);
								}
							}
						})
						if (collectionLabel && tagLabels.length > 0) {
							labelText = collectionLabel + ': ' + tagLabels.join(', ');
						} else {
							labelText = collectionLabel;
						}
					}

					// Other filter option label
				} else if (this.refineBy && this.refineBy.refineByItems) {
					var refineByLabels = [];
					this.refineBy.refineByItems.forEach(refineByItem => {
						if (refineByItem.filterOptionId == filterOption.filterOptionId) {
							var label = Utils.stripHtml(refineByItem.label);
							if (label) {
								refineByLabels.push(label);
							}
						}
					})
					labelText = refineByLabels.join(', ');
				}
              switch (labelText) {
                    case 'Yper-anthektika':
      labelText = 'Υπέρ-ανθεκτικά';
      break;
    case 'Extra Agapi':
      labelText = 'Έξτρα αγάπη';
      break;
    case 'Eykola':
      labelText = 'Εύκολα';
      break;
    case 'Iliolousto Simeio':
      labelText = 'Ηλιόλουστο Σημείο';
      break;
    case 'Skiero Simeio':
      labelText = 'Σκιερό Σημείο';
      break;
    case 'Tha Ta Kataferei Pantou':
      labelText = 'Θα τα καταφέρει παντού';
      break;
    case 'Foteino Simeio':
      labelText = 'Φωτεινό Σημείο';
      break;
    case 'Megala':
      labelText = 'Μεγάλα (+1m)';
      break;
    case 'Mesaia':
      labelText = 'Μεσαία (50cm-1m)';
      break;
    case 'Mikra':
      labelText = 'Μικρά (5-50cm)';
      break;
    case 'Mpalkoni':
        labelText = 'Μπαλκόνι';
        break;
    case 'Khpos':
        labelText = 'Κήπος';
        break;
      case 'Anthizei':
        labelText = 'Ανθίζει';
        break;
      case 'De Rixnei Fylla':
        labelText = 'Δε Ρίχνει Φύλλα';
        break;
      case 'Entypwsiakh Emfanish':
        labelText = 'Εντυπωσιακή εμφάνιση';
        break;
      case 'Fysikos Fraxtis':
        labelText = 'Φυσικός φράχτης';
        break;
      case 'Anthektiko Se Aera':
        labelText = 'Ανθεκτικό Σε Αέρα';
        break;
      case 'Anthektiko Se Pageto':
        labelText = 'Ανθεκτικό Σε Παγετό';
        break;
      case 'Eyxaristo Arwma':
        labelText = 'Ευχάριστο Άρωμα';
        break;
      case 'Polyeth':
        labelText = 'Πολυετή';
        break;
      case 'Epoxiaka':
        labelText = 'Εποχιακά';
        break;
      case 'Anoixh':
        labelText = 'Άνοιξη';
        break;
      case 'Kalokairi':
        labelText = 'Καλοκαίρι';
        break;
      case 'Fthinopwro':
        labelText = 'Φθινόπωρο';
        break;
      case 'Xeimwnas':
        labelText = 'Χειμώνας';
        break;
      case 'Tropika':
        labelText = 'Τροπικά';
        break;
      case 'Arwmatika':
        labelText = 'Αρωματικά';
        break;
      case 'Thamnoeidh':
        labelText = 'Θαμνοειδή';
        break;
      case 'Loyloydia':
        labelText = 'Λουλούδια';
        break;
      case 'Dendroeidh':
        labelText = 'Δενδροειδή';
        break;
      case 'Anarrixwmena':
        labelText = 'Αναρριχώμενα';
        break;
      case 'Kaktoi & Paxyfyta':
        labelText = 'Κάκτοι & Παχύφυτα';
        break;
      /* Boost-230412 */            
      case 'Kaspo':
        labelText = 'Κασπώ';
        break;
      case 'Glastra':
        labelText = 'Γλάστρα';
        break;
      case 'Mikra (ews 14cm)':
        labelText = 'Μικρά (έως 14cm)';
        break;
      case 'Mesaia (14-20cm)':
        labelText = 'Μεσαία (14-20cm)';
        break;
      case 'Megala (>20cm)':
        labelText = 'Μεγάλα (>20cm)';
        break;
      case 'Xeiropoihto':
        labelText = 'Χειροποίητο';
        break;
    // Add more cases as needed
    // case 'AnotherLabel':
    //   this.label = 'AnotherValue';
    //   break;

    default:
      // Default case if none of the above matches
      // You might want to keep the original value or handle it differently
      break;
              }
				var labelHtml = labelText ? '<span>' + Utils.stripHtml(labelText) + '</span>' : '';
				filterOption.$element.find(this.selector.refineByOnTitle).html(labelHtml);
			}
		})
	}
  ProductList.prototype.afterRender = function (data) {
    if (!data) data = this.data;
    
    
  }
  
  
  // Build Additional Elements
  Filter.prototype.afterRender = function (data, eventType) {
    if (!data) data = this.data;
     var filterOptionIds = Object.keys(Globals.queryParams).filter(key => key.startsWith(Globals.prefix));
      var numberResults;
      
      
    
//       if(filterOptionIds != undefined && filterOptionIds.length != 0) {
//           if(filterOptionIds.length == 2 ){
//               numberResults = Globals.queryParams[filterOptionIds[0]].length
               
//           }else if (filterOptionIds.length > 2) {
//               numberResults = filterOptionIds.length - 1
             
//           }else {
//               numberResults = Globals.queryParams[filterOptionIds].length
//           }
//       }else {
//         numberResults='';
//       }
       if(filterOptionIds != undefined && filterOptionIds.length != 0) {
         jQ('.boost-pfs-filter-tree-mobile-button-label').html(boostPFSAppConfig.settings.label.refineMobile + ' <span class= "visuaAid">*</span>')
       }else {
          jQ('.boost-pfs-filter-tree-mobile-button-label').html(boostPFSAppConfig.settings.label.refineMobile )
       }
      
      
     
     
    jQ('.boost-pfs-filter-total-product').html(data.total_product + ' products');
   
    

  };
 
  
  
  /************************** END BUILD TOOLBAR **************************/
})();